import React from 'react';
import styled from 'styled-components';

const StyledContainer = styled.div`
  width: 100%;
  max-width: ${props => props.width || '1200px'};
  margin: 0 auto;
  padding: 0 ${props => props.padding || '1rem'};
`;

const Container = ({ children, width, padding, ...props }) => {
  return (
    <StyledContainer width={width} padding={padding} {...props}>
      {children}
    </StyledContainer>
  );
};

export default Container;